var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M10 14.5C11.3807 14.5 12.5 13.3807 12.5 12C12.5 10.6193 11.3807 9.5 10 9.5C8.61929 9.5 7.5 10.6193 7.5 12C7.5 13.3807 8.61929 14.5 10 14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M20 2V1C20 0.45 19.55 0 19 0C18.45 0 18 0.45 18 1V2H17C16.45 2 16 2.45 16 3C16 3.55 16.45 4 17 4H18V5C18 5.55 18.45 6 19 6C19.55 6 20 5.55 20 5V4H21C21.55 4 22 3.55 22 3C22 2.45 21.55 2 21 2H20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M16 6H15C14.45 6 14 5.55 14 5V2H7.88C7.32 2 6.78 2.24 6.4 2.65L5.17 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H18C19.1 20 20 19.1 20 18V8H17C16.45 8 16 7.55 16 7V6ZM10 16.5C7.52 16.5 5.5 14.48 5.5 12C5.5 9.52 7.52 7.5 10 7.5C12.48 7.5 14.5 9.52 14.5 12C14.5 14.48 12.48 16.5 10 16.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photoIcon.aef362fa.svg";
export { ForwardRef as ReactComponent };